import styled, { css } from 'styled-components';

export const SectionPeriod = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  overflow: hidden;
`;

export const SectionPeriodTitle = styled.p`
  ${({ theme }) => css`
    font-size: ${theme.v3.font.sizes['1xmedium']};
    font-weight: ${theme.v3.font.weights.medium};
    line-height: ${theme.v3.font.lineHeight.comfortable};
    color: ${theme.v3.colors.neutral[20]};
    margin: 0;
  `}
`;

export const PeriodButtonsWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    gap: 16px;
    align-items: stretch;
    width: 100%;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      flex-wrap: wrap;
      display: grid;
      grid-template-columns: repeat(2, 1fr);
    }
  `}
`;

export const PeriodButtonWrapper = styled.div`
  position: relative;
  flex: 1;
  max-width: 25%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
`;

export const BestValueBadge = styled.span`
  ${({ theme }) => css`
    position: absolute;
    top: -12px;
    left: 50%;
    transform: translateX(-50%);
    background: linear-gradient(90deg,
      ${theme.v3.colors.brand.snappyBlue[60]} 0%,
      #02AEF2 20%,
      #2BC5EF 40%,
      #5CDAE9 60%,
      #8BEDE6 80%,
      ${theme.v3.colors.accent.green[95]} 100%
    );
    color: ${theme.v3.colors.brand.snappyBlue[10]};
    font-size: ${theme.v3.font.sizes.mini};
    font-weight: ${theme.v3.font.weights.medium};
    line-height: ${theme.v3.font.lineHeight.compact};
    padding: 6px 8px;
    border-radius: 24px;
    white-space: nowrap;
  `}
`;

export const PeriodButton = styled.button`
  ${({ theme, isSelected }) => css`
    width: 100%;
    height: 100%;
    min-height: 56px;
    padding: 16px;
    border-radius: ${theme.v3.border.radius.xl};
    border: 1px solid ${isSelected ? theme.v3.colors.brand.snappyBlue[50] : theme.v3.colors.neutral[90]};
    background-color: ${isSelected ? theme.v3.colors.brand.snappyBlue[95] : theme.v3.colors.neutral[100]};
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: border-color 0.2s, background-color 0.2s;

    &:hover:not(:disabled) {
      border-color: ${theme.v3.colors.brand.snappyBlue[50]};
      background-color: ${theme.v3.colors.brand.snappyBlue[98]};
    }
  `}
`;

export const PeriodButtonLabel = styled.span`
  ${({ theme, isSelected }) => css`
    font-family: ${theme.v3.font.family.brand};
    font-size: ${theme.v3.font.sizes.small};
    font-weight: ${theme.v3.font.weights.medium};
    line-height: ${theme.v3.font.lineHeight.comfortable};
    color: ${isSelected ? theme.v3.colors.brand.snappyBlue[50] : theme.v3.colors.neutral[20]};
    text-align: center;
  `}
`;

export const PeriodButtonCurrentLabel = styled.span`
  ${({ theme, isSelected }) => css`
    font-family: ${theme.v3.font.family.brand};
    font-size: ${theme.v3.font.sizes.mini};
    font-weight: ${theme.v3.font.weights.medium};
    line-height: ${theme.v3.font.lineHeight.compact};
    color: ${isSelected ? theme.v3.colors.brand.snappyBlue[50] : theme.v3.colors.neutral[20]};
    text-align: center;
    white-space: nowrap;
  `}
`;

export const SavingsBanner = styled.div`
  ${({ theme, isLast }) => css`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 16px;
    border-radius: ${theme.v3.border.radius.xl};
    background: ${isLast
    ? `linear-gradient(90deg,
          ${theme.v3.colors.brand.snappyBlue[10]} 0%,
          ${theme.v3.colors.brand.snappyBlue[40]} 100%
        )`
    : `linear-gradient(95deg,
          ${theme.v3.colors.brand.snappyBlue[40]} 45.81%,
          #0082B8 56.65%,
          #26A3C5 67.49%,
          #56C2D0 78.32%,
          #87E1DA 89.16%,
          ${theme.v3.colors.accent.green[95]} 100%
        )`
};
    width: 100%;
  `}
`;

export const SavingsBannerText = styled.p`
  ${({ theme }) => css`
    font-size: ${theme.v3.font.sizes.small};
    font-weight: ${theme.v3.font.weights.medium};
    line-height: ${theme.v3.font.lineHeight.comfortable};
    color: ${theme.v3.colors.neutral[100]};
    margin: 0;
  `}
`;

export const SectionDivider = styled.hr`
  ${({ theme }) => css`
    border: none;
    border-top: 1px solid ${theme.v3.colors.neutral[90]};
    margin: 24px 0;
    width: 100%;

    @media (max-width: ${theme.v3.breakpoints.md}) {
      margin: 16px 0;
    }
  `}
`;
